import { featureCollection } from '@turf/helpers';
import { createEntityAdapter } from 'redux-ngrx-entity';
import { Region } from './region.models';
import type { RegionState } from './region.store';

export const regionAdapter = createEntityAdapter<Region>();

export const getInitialRegionState = (): RegionState =>
  regionAdapter.getInitialState({
    status: 'idle',
    selectedRegionId: 'root',
    propertyFeatureCollection: featureCollection([]),
    easyScoutFieldHover: [],
    hoveredFieldId: null,
    favoriteFieldsId: [],
  });
